import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { scrollInvalidControl } from '../../shared/scroll';

@Directive({
  selector: '[appSelectionChangeScrollInvalidControl]'
})
export class SelectionChangeScrollInvalidControlDirective implements AfterViewInit {

  constructor(private el: ElementRef, private host: MatStepper) { }

  ngAfterViewInit() {
    this.el.nativeElement.querySelectorAll('mat-step-header').forEach(item => {
      item.addEventListener('click', event => {
        const index = event.currentTarget.ariaPosInSet - 1;
        if (this.host.selectedIndex !== index) {
          scrollInvalidControl(this.el.nativeElement.querySelector('div[role="tabpanel"]:not(.mat-horizontal-stepper-content-inactive)'));
        }
      });
    });
  }
}
